export default function About() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-20">
          <div className="flex-1 text-center lg:text-left">
            <div className="flex items-center gap-3 mb-3 justify-center lg:justify-start">
              <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center">
                <i className="ri-information-line text-accent-500 text-xl"></i>
              </div>
              <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">关于羞羞漫画</h2>
            </div>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4 max-w-2xl mx-auto lg:mx-0">
              羞羞漫画是国内领先的在线漫画阅读平台，致力于为广大漫画爱好者提供海量韩漫、日漫、国漫免费阅读服务。平台采用创新的下拉式阅读技术，摆脱传统翻页束缚，让读者沉浸在流畅的漫画世界中。
            </p>
            <p className="text-foreground-500 text-sm leading-relaxed mb-6 max-w-2xl mx-auto lg:mx-0">
              自上线以来，羞羞漫画已收录超过3000部优质漫画作品，涵盖恋爱、玄幻、校园、悬疑、耽美等多种题材，每日更新200+话内容。我们坚持免费阅读理念，拒绝强制广告，用心打造纯净的漫画阅读社区。
            </p>
            <div className="grid grid-cols-3 gap-4 max-w-md mx-auto lg:mx-0">
              <div className="text-center p-4 rounded-xl bg-background-100">
                <div className="text-2xl font-bold text-primary-500 font-heading">3000+</div>
                <div className="text-xs text-foreground-500 mt-1">收录作品</div>
              </div>
              <div className="text-center p-4 rounded-xl bg-background-100">
                <div className="text-2xl font-bold text-accent-500 font-heading">200+</div>
                <div className="text-xs text-foreground-500 mt-1">日更话数</div>
              </div>
              <div className="text-center p-4 rounded-xl bg-background-100">
                <div className="text-2xl font-bold text-secondary-500 font-heading">500万+</div>
                <div className="text-xs text-foreground-500 mt-1">活跃读者</div>
              </div>
            </div>
          </div>
          <div className="flex-shrink-0 w-full max-w-[400px] lg:w-[360px] h-[280px] rounded-2xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Cozy%20reading%20atmosphere%20illustration%20with%20warm%20coral%20and%20cream%20color%20palette%2C%20person%20reading%20manga%20on%20tablet%20in%20comfortable%20setting%2C%20soft%20natural%20light%2C%20modern%20flat%20illustration%20style%2C%20relaxing%20vibe%2C%20no%20text&width=720&height=560&seq=about-visual-01&orientation=landscape"
              alt="羞羞漫画 - 舒适阅读体验"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
}